import styled from 'styled-components'
import { Button } from '@/components/button'
import SparkleSVG from './../sparkle.svg?react'

const StyledSVG = styled(SparkleSVG)`
  margin-right: 4px;
`

type SmartButtonProps = React.ComponentProps<typeof Button>

const SmartButton: React.FC<SmartButtonProps> = ({ children, theme = 'secondary', ...rest }) => {
  return (
    <Button theme={theme} size="small" {...rest}>
      <StyledSVG />
      {children}
    </Button>
  )
}

export default SmartButton
